
import React, { useEffect,useState } from 'react';
//import { cashfree } from './util';
import { useParams } from 'react-router-dom';
import { checkPaymentStatusRequest } from '../../../redux/sagas/Subscription/SubscriptionSlice';
import { useDispatch, useSelector } from 'react-redux';

const CashfreePaymentStatus = () => {
  const dispatch = useDispatch();
  const { orderId } = useParams();
  const { payment_info, loading, error } = useSelector(state => state.subscriptionPlan);

  const [status, setStatus] = useState('Checking payment status...');
  const [details, setDetails] = useState(null);
  useEffect(() => {
    if (!orderId) {
      console.error('Missing sessionId or orderId in URL params');
      return;
    }

   dispatch(checkPaymentStatusRequest({ orderId }));

  }, [ orderId]);
  


  return(<div className="main">
    <h1>hello</h1>
      {loading && <h1>Checking payment status...</h1>}
      {error && <h1 style={{ color: 'red' }}>Error: {error}</h1>}
      {!loading && !error && payment_info && (
        <>
          <h1>Payment Status: {payment_info.payment_status}</h1>
          <pre>{JSON.stringify(payment_info, null, 2)}</pre>
        </>
      )}
    </div>
  )
};

export default CashfreePaymentStatus;
